import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CustomButton from "../../components/Common/CustomButton";
import { CargoVideoUrl } from "../../constants";
import { toastError, toastSuccess } from "../../utils";
import * as actions from "./actions";
import AuthInput from "./AuthInput";
const queryString = require("query-string");

const initialUser = {
  password: "",
  confirmPassword: "",
  passwordResetToken: "",
};

function ResetPassword() {
  const history = useHistory();
  const location = useLocation();

  const [user, setUser] = useState({ ...initialUser });
  const [loginLoader, setLoginLoader] = useState(false);

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    if (parsed.accessToken) {
      setUser({ ...user, passwordResetToken: parsed.accessToken });
    } else {
      // history.push("/login");
    }
  }, []);

  const onChangeHandler = (e) => {
    const { name = "", value = "" } = e.target;
    setUser({ ...user, [name]: value });
  };

  const keyPressed = (e) => {
    if (e.key === "Enter") {
      if (!loginLoader) {
        onConfirmEmail();
      }
    }
  };

  const onConfirmEmail = () => {
    if (!user.password || !user.confirmPassword) return;
    if (user.password !== user.confirmPassword)
      return toastError("Password mismatch");
    setLoginLoader(true);
    actions
      .updatePassword({
        password: user.password,
        accessToken: user.passwordResetToken,
      })
      .then((res) => {
        setLoginLoader(false);
        toastSuccess("Password has been reset successfully");
        history.push("/login");
      })
      .catch((err) => {
        setLoginLoader(false);
        toastError(err?.data?.message || "Failed to reset password");
      });
  };

  return (
    <div className="relative w-full h-screen overflow-hidden flex items-center justify-center md:justify-end bg-slate-900 md:pr-28">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          className="w-full h-full object-cover"
        >
          <source src={CargoVideoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* Sleek right-to-left gradient overlay */}
        {/* <div className="absolute inset-0 bg-gradient-to-l from-[#0a1a36]/90 via-[#0a1a36]/40 to-transparent backdrop-blur-[1px]" /> */}
      </div>

      {/* Main SaaS Card Container with layout transition and spacious width/padding */}
      <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", stiffness: 380, damping: 35 }}
        className="relative z-10 w-full max-w-[440px] mx-4 bg-white rounded-[24px] p-6 sm:p-8 border border-slate-100/80 shadow-[0_20px_50px_rgba(16,63,107,0.08)] flex flex-col gap-4"
      >
        {/* Header Text */}
        <div className="text-center flex flex-col gap-1 mb-1">
          <h2 className="text-2xl font-bold text-[#0a2540] tracking-tight">
            Reset Password
          </h2>
          <p className="text-xs font-medium text-slate-400 max-w-[320px] mx-auto leading-relaxed">
            Choose a strong new password for your account.
          </p>
        </div>

        {/* Input fields */}
        <div className="flex flex-col gap-3 text-left">
          <AuthInput
            type="password"
            name="password"
            placeholder="••••••••"
            label="New Password"
            value={user.password}
            onChange={onChangeHandler}
          />
          <AuthInput
            type="password"
            name="confirmPassword"
            placeholder="••••••••"
            label="Confirm Password"
            value={user.confirmPassword}
            onChange={onChangeHandler}
            onKeyPress={keyPressed}
          />
        </div>

        {/* Action Button */}
        <div className="flex flex-col gap-4 mt-1">
          <CustomButton
            onClick={onConfirmEmail}
            loader={loginLoader}
            disabled={loginLoader}
            className="bg-[#0a2540] hover:bg-[#001c3d] text-white py-3.5 rounded-2xl font-semibold tracking-wide shadow-lg shadow-[#0a2540]/10 hover:shadow-[#0a2540]/20 transition-all duration-300 w-full text-sm border-none cursor-pointer"
          >
            Reset Password
          </CustomButton>
        </div>

        {/* Footer Link */}
        <div className="text-center pt-2">
          <p className="text-sm text-slate-500">
            Back to?{" "}
            <button
              type="button"
              onClick={() => history.push("/login")}
              className="text-[#313C4C] font-bold hover:text-sky-800 transition-colors duration-200 focus:outline-none cursor-pointer bg-transparent border-none"
            >
              Login
            </button>
          </p>
        </div>
      </motion.div>
    </div>
  );
}

export default ResetPassword;
